/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Overlap_ProtectionInputs */

const en_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlap Protection`)
};

const fr_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protection contre le chevauchement`)
};

const de_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappungsschutz`)
};

const it_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protezione da sovrapposizione`)
};

const ru_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защита от перекрытия`)
};

const es_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protección contra superposiciones`)
};

const zh_cn2_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重叠保护`)
};

const ja_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複保護`)
};

const hi_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप सुरक्षा`)
};

const pt_pt2_options_editor_overlap_protection = /** @type {(inputs: Options_Editor_Overlap_ProtectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteção contra sobreposição`)
};

/**
* | output |
* | --- |
* | "Overlap Protection" |
*
* @param {Options_Editor_Overlap_ProtectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_overlap_protection = /** @type {((inputs?: Options_Editor_Overlap_ProtectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Overlap_ProtectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_overlap_protection(inputs)
	if (locale === "de") return de_options_editor_overlap_protection(inputs)
	if (locale === "it") return it_options_editor_overlap_protection(inputs)
	if (locale === "ru") return ru_options_editor_overlap_protection(inputs)
	if (locale === "es") return es_options_editor_overlap_protection(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_overlap_protection(inputs)
	if (locale === "ja") return ja_options_editor_overlap_protection(inputs)
	if (locale === "hi") return hi_options_editor_overlap_protection(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_overlap_protection(inputs)
	return en_options_editor_overlap_protection(inputs)
});